<script lang="ts">
  import { countVisibleCharacters } from '../helpers';

  // out
  export let value: string;

  // in
  export let label = '',
    placeholder = '',
    size: '2xlarge' | 'xhuge' | 'giant' = 'xhuge',
    name = '',
    disabled = false,
    extend = false,
    resizable = true,
    maxLength: number = 0,
    cols: number | null = null,
    rows: number | null = null;

  // generate unique id for input since
  // crypto.randomUUID() is giving error
  const id =
    'id_' + Date.now().toString(36) + Math.random().toString(36).substr(2, 5);
</script>

<div class="textarea-wrapper" class:extend>
  {#if label}
    <label for={id} class="label">{label}</label>
  {/if}

  <textarea
    class="textarea"
    class:resizable
    class:is-md={size === '2xlarge'}
    class:is-lg={size === 'xhuge'}
    class:is-xl={size === 'giant'}
    bind:value
    {name}
    {id}
    {disabled}
    {placeholder}
    {cols}
    {rows}
    maxlength={maxLength ? maxLength : undefined}
    on:input
    on:keyup
    on:blur
    on:focus
  />

  {#if maxLength}
    <div class="counter">
      {value.length} / {maxLength}
    </div>
  {/if}
</div>

<style lang="scss">
  .textarea-wrapper {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    &.extend,
    &.extend .textarea {
      width: 100%;
    }
  }

  .label {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0.14px;
    color: var(--color-neutralBlack);
  }

  .textarea {
    margin: var(--spacing-nano) 0;
    padding: var(--spacing-mini);
    resize: none;
    background-color: var(--color-neutralWhite);
    box-shadow:
      0px 1px 2px 0px rgba(0, 0, 0, 0.02),
      0px 2px 4px 0px rgba(17, 17, 17, 0.04);
    border-radius: 4px;
    border: 1px solid var(--color-neutralExtraLight);
    transition: all 0.15s ease-in-out;

    &:focus,
    &:focus-visible {
      outline: none;
      border-color: var(--color-primary);
      background-color: var(--color-primary-light);
    }

    &:disabled {
      background-color: var(--color-background-light);
    }

    &.resizable {
      resize: vertical;
    }

    &.is-md {
      font-size: 12px;
    }
    &.is-lg {
      font-size: 14px;
    }
    &.is-xl {
      font-size: 16px;
    }
  }

  .counter {
    position: absolute;
    bottom: calc(var(--spacing-mini) + var(--spacing-nano));
    right: var(--spacing-mini);
    font-size: 12px;
    color: var(--color-neutralGreyLight);
    pointer-events: none;
  }
</style>
